<template>
  <td class="table--access">
    <Tag
      v-model="access"
      :list="list"
      v-on:addTag="addTag"
      v-on:removeTag="removeTag"
      inputPlaceholder="Add application"
    />
  </td>
</template>

<script>
  import { API } from '../../../services/api.ts';
  import Tag from '../../../components/form/tag.vue'

  export default {
    name: 'TdAccess',
    components: {
      Tag
    },
    props: [
      'access',
      'list',
      'id'
    ],
    methods: {
      addTag: function(currentIds, value) {
        console.log(value);

        API.patch(
          `index.cfm?act=accounts.item&id=${this.id}`,
          {
            addApplications: `${currentIds}`
          }
        ).then(
          response => {
            console.log(response);
          }
        )
      },
      removeTag: function(tagId, value) {
        API.patch(
          `index.cfm?act=accounts.item&id=${this.id}`,
          {
            removeApplications: `${tagId}`
          }
        ).then(
          response => {
            console.log(response);
          }
        )
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../styles/components/mediaQueries.scss";

  .table--access {
    width: 40%;
  }

  @include media-sm {

    .table--access {
      width: 100%;

      .tag {
        height: auto;
      }
    }
  }
</style>
